webpackJsonp([14],{

/***/ 171:
/***/ (function(module, exports) {

module.exports = {"jugar":"Play","instrucciones":"Instructions"}

/***/ })

});


// WEBPACK FOOTER //
// static/js/14.ebbd0800d93afd0feb07.js